import type { FeatureConfig } from "src/feature/FeatureConfig";
import type { FeatureFlag } from "src/feature/useFeatureFlag";

export type BackendFeatureMap = {
  [key in FeatureFlag]: Partial<FeatureConfig>;
};

// ***Important***
// Experiment configuration of features takes precedence over this mapping.
// So if an experiment is running and configured in ./experiment/getFeatureConfigForExperimentConfig.ts
// Any mapping here will NOT take effect.
// See precedence order here: https://github.com/rome2rio/rome2rio-explore/blob/6aa02e41dfb026a65595675c4ccf4dd2cf82effd/apps/explore/src/feature/internal/useConfigureFeatures.ts#L7
//
// If the backend feature is enabled, set the frontend features here.
//
// If possible, use the backend feature flag directly instead of mapping it to a frontend feature.
// See: useFeatureFlag.ts.
export const backendFeatureMapping: Partial<BackendFeatureMap> = {
  ShowDebug: {
    Debug: true,
  },
  HotelPromoDriveSegment: {
    HotelPromoDriveSegment: true,
  },
  RefreshAdUnits: {
    RefreshAdUnits: true,
  },
  DriveRoutes: {
    DriveRoutes: true,
  },
};
